/**
 * Role codes that match the API response from /api/v1beta/access/roles
 * These are the role.code values returned by the backend
 */
export const ROLE_CODE_LIST = {
  ADMIN_ONAY_BILIM: 'ADMIN_ONAY_BILIM',
  ADMIN_SCHOOL: 'ADMIN_SCHOOL',
  CAFETARIA_GUEST: 'CAFETARIA_GUEST',
  DASHBOARD_VIEWER: 'DASHBOARD_VIEWER',
  MANAGER_ONAY_BILIM: 'MANAGER_ONAY_BILIM',
  MANAGER_SUPERVISORY_AUTHORITY: 'MANAGER_SUPERVISORY_AUTHORITY',
  MANAGER_SCHOOL: 'MANAGER_SCHOOL',
} as const

export type RoleCode = (typeof ROLE_CODE_LIST)[keyof typeof ROLE_CODE_LIST]

/**
 * Predefined role groups for common access patterns
 */
export const ROLE_GROUPS = {
  /** Roles that can access canteen dashboard */
  CANTEEN_DASHBOARD_ACCESS: [
    ROLE_CODE_LIST.ADMIN_ONAY_BILIM,
    ROLE_CODE_LIST.ADMIN_SCHOOL,
    ROLE_CODE_LIST.CAFETARIA_GUEST,
  ] as const,

  /** Roles that should only see the canteen dashboard (redirected from all other pages) */
  DASHBOARD_ONLY: [ROLE_CODE_LIST.CAFETARIA_GUEST] as const,
} as const

export type RoleGroup = keyof typeof ROLE_GROUPS

/**
 * Helper to check if user has any of the specified roles
 */
export const hasAnyRole = (
  userRoles: Array<{ code: string }> | undefined,
  allowedRoles: readonly string[]
): boolean => {
  if (!userRoles) return false
  return userRoles.some((role) => allowedRoles.includes(role.code))
}

/**
 * Helper to check if user has a specific role
 */
export const hasRole = (
  userRoles: Array<{ code: string }> | undefined,
  roleCode: string
): boolean => {
  if (!userRoles) return false
  return userRoles.some((role) => role.code === roleCode)
}

export const ROLE_LABELS = {
  ADMIN_ONAY_BILIM: { ru: 'Администратор Onay Bilim', kk: 'Onay Bilim әкімшісі' },
  ADMIN_SCHOOL: { ru: 'Администратор школы', kk: 'Мектеп әкімшісі' },
  MANAGER_ONAY_BILIM: { ru: 'Менеджер Onay Bilim', kk: 'Onay Bilim менеджері' },
  MANAGER_SCHOOL: { ru: 'Менеджер школы', kk: 'Мектеп менеджері' },
  MANAGER_SUPERVISORY_AUTHORITY: {
    ru: 'Менеджер надзорного органа',
    kk: 'Қадағалау органының менеджері',
  },
  DASHBOARD_VIEWER: { ru: 'Просмотр дашборда', kk: 'Дашборд көру' },
  parent: { ru: 'Родитель', kk: 'Ата-ана' },
} as const
